/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ id: NonNullable<unknown> }} Job_PlaceholderInputs */

const en_job_placeholder = /** @type {(inputs: Job_PlaceholderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Position ${i?.id}`)
};

const de_job_placeholder = /** @type {(inputs: Job_PlaceholderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Position ${i?.id}`)
};

/**
* | output |
* | --- |
* | "Position {id}" |
*
* @param {Job_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_placeholder = /** @type {((inputs: Job_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_placeholder(inputs)
	return en_job_placeholder(inputs)
});